import { Card } from "../../../../components/card/card";
import NotificationsService from "../../../../services/web/notification-service";
import platePatternUtils from "../../../../utils/plate-pattern-utils"

const NotificationPassages = ({ name, passage, openModal }) => {
    const plate = platePatternUtils.formatted(platePatternUtils.cleanRawPlate(passage?.plate));
    const src = passage?.attachId  ? NotificationsService.attachUrl(passage.attachId): NotificationsService.attachError;
    const pattern = plate?.pattern ?? "WITHOUT_PATTERN";

    return (
    <>
        <h3 className="text-lg! font-semibold">{name}</h3>
        <Card className={"border-zinc-200"}>
            <Card.Body>
                <div className="h-full flex flex-col items-center justify-center p-1 select-none ">
                    <img 
                        className="max-h-full max-w-full object-contain" 
                        src={src} 
                        alt={plate?.formattedValue}
                        onClick={() => {
                            if (!passage?.attachId) return;
                            openModal(NotificationsService.attachUrl(passage.attachId));
                        }}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = NotificationsService.attachError;
                            e.currentTarget.style.pointerEvents = "none";
                        }}
                    />

                    {plate?.formattedValue && (
                        <div className="vehicle-plate my-1 w-[115px]">
                            <div className={`product-heading ${pattern}`} />
                            <div className={`product-body ${pattern}`}>
                                {plate.formattedValue}
                            </div>
                        </div>
                    )}
                </div>
            </Card.Body>
        </Card>
    </>
    )
}

export default NotificationPassages;